import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BRAND } from '../../theme/brandTokens';
import { useProUpgrade } from '../../context/ProUpgradeContext';
import ProCrownButton from './ProCrownButton';
import PrimaryActionButton from '../common/PrimaryActionButton';

const ProFeatureLockedPage = () => {
  const { t } = useTranslation();
  const { openProUpgrade } = useProUpgrade();

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 160px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
        py: 8,
        gap: 2,
      }}
    >
      <ProCrownButton locked size="large" stopPropagation={false} />
      <Typography variant="h5" sx={{ fontWeight: 700, color: BRAND.text, maxWidth: 480 }}>
        {t('storePlan.upgradeDialog.lockedPageTitle')}
      </Typography>
      <Typography variant="body2" sx={{ color: BRAND.textMuted, maxWidth: 440 }}>
        {t('storePlan.upgradeDialog.lockedPageSubtitle')}
      </Typography>
      <PrimaryActionButton onClick={openProUpgrade} sx={{ mt: 1 }}>
        {t('storePlan.upgradeToPro')}
      </PrimaryActionButton>
    </Box>
  );
};

export default ProFeatureLockedPage;
